"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: '시간 선택',
  rangePlaceholder: ['시작 시간', '종료 시간']
};
var _default = locale;
exports["default"] = _default;